/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_SortInputs */

const cs_documents_sort = /** @type {(inputs: Documents_SortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Řadit`)
};

const en_documents_sort = /** @type {(inputs: Documents_SortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort`)
};

/**
* | output |
* | --- |
* | "Sort" |
*
* @param {Documents_SortInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_sort = /** @type {((inputs?: Documents_SortInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_SortInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_sort(inputs)
	return cs_documents_sort(inputs)
});